import type { WorkspaceToolsKey } from "./ru";

const en: Record<WorkspaceToolsKey, string> = {
	"catalog-title": "Shared materials",
	"group-fragments": "Fragments",
	"group-templates": "Templates",
	"scope-title": "the shared materials",
	"fragment-loading": "The fragment will appear once the shared materials have loaded",
	"fragment-failed": "Fragment {{id}} is not shown: the shared materials failed to load",
	"reserved-name": "This name is taken by the shared materials",
	"error-mismatch": "The shared materials folder holds another repository",
	"error-empty": "The shared materials repository has no master branch",
	"error-no-access":
		"The shared materials repository was not found, or you have no access to it. Contact the workspace administrator.",
	"error-unreadable": "Could not read the published shared materials",
	"error-broken": "The shared materials repository may be damaged. Reload it.",
	"error-no-server-source": "No Gramax Enterprise Server address is set to load the shared materials from",
};

export default en;
